import { Link } from 'react-router-dom';
import { CartDrawer } from '@components/cart/CartDrawer';
import { CheckoutForm } from '@components/cart/CheckoutForm';
import { useCart } from '../hooks/useCart';

export function CartPage() {
  const { itemCount } = useCart();

  return (
    <div className="mx-auto max-w-2xl">
      <div className="mb-8">
        <Link to="/" className="text-sm text-gray-400 hover:text-white transition-colors">&larr; Continue Shopping</Link>
        <h1 className="mt-2 text-3xl font-bold text-white">Shopping Cart</h1>
        <p className="text-sm text-gray-400">{itemCount} item{itemCount !== 1 ? 's' : ''}</p>
      </div>

      <CartDrawer />

      {itemCount > 0 && (
        <div className="mt-8">
          <CheckoutForm />
        </div>
      )}
    </div>
  );
}
